import { useQuery } from "@tanstack/react-query"
import { useAuth } from "@clerk/clerk-react"

const API_BASE = import.meta.env.VITE_API_URL || ""

async function fetchWithAuth<T>(url: string, getToken: () => Promise<string | null>): Promise<T> {
  const token = await getToken()
  const res = await fetch(`${API_BASE}${url}`, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  })
  if (!res.ok) {
    throw new Error(`API error: ${res.status}`)
  }
  return res.json()
}

export interface TenantAnalyticsResponse {
  collection_rate: number
  avg_days_to_payment: number
  outstanding_amount: number
  outstanding_count: number
  platform_avg_collection_rate: number
  platform_avg_days: number
}

export function useTenantAnalytics() {
  const { getToken } = useAuth()
  return useQuery({
    queryKey: ["tenant-analytics"],
    queryFn: () => fetchWithAuth<TenantAnalyticsResponse>("/api/analytics/overview", getToken),
  })
}
